import styles from './TestimonialsHeader.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuoteLeft, faQuoteRight } from '@fortawesome/free-solid-svg-icons';

function TestimonialsHeader() {
    return (
        <div className={styles['testimonials-header']}>
            <FontAwesomeIcon
                icon={faQuoteLeft}
                className={`${styles['testimonials-header-icon']} ${styles['testimonials-header-icon__start']}`}
            />

            <h1 className={styles['testimonials-header-text']}>
                I am fortunate to have a career working alongside exceptional professionals with
                whom I have dedicated myself to delivering value to our customers and users. I am
                deeply grateful for their testimonials, which serve as a testament to our collective
                efforts.
            </h1>

            <FontAwesomeIcon
                icon={faQuoteRight}
                className={`${styles['testimonials-header-icon']} ${styles['testimonials-header-icon__end']}`}
            />
        </div>
    );
}

export default TestimonialsHeader;
